export const LIGHT_BLACK = "#616161";
export const LIGHT_GREY = "#F9F9F9";
export const MID_GREY = "#CFCFCF";
export const INTENSE_GRAY = "#B0B0B0";
export const SYSTEM_BLUE = "#127FFF";
export const PRIMARY = "#2813AD";
export const RED = "#EA5151";
export const DELETE_RED = "#B02F2F";
export const BLACK = "#1D1D1D";
